module.exports = __webpack_public_path__ + "static/air-asia-5d7d4f70d172b870bd4c6edb1990088a.png";